import React, { useContext, useEffect, useState } from "react";
import Overlay from "../Overlay/index.jsx";
import { useNavigate } from "react-router-dom";
import AppContext from "../../AppContext.jsx";
import { langComponent } from "../../constants/index.jsx";
import { CART_STEP, CartContext } from "../../contexts/CartContext.jsx";

//style
import "../../styles/shoppingCart.scss";

//image
import { ReactComponent as CloseSvg } from "../../assets/admin/close.svg";

import Items from "./Items.jsx";
import PaymentForm from "./PaymentForm.jsx";
import _ from "lodash";
import { Summary } from "./Summary.jsx";
import PaymentSuccess from "./PaymentSuccess.jsx";

const Cart = ({ onClose }) => {
  const { getLang } = useContext(AppContext);
  const { items, removeItem, step, restartForm, charge, journal } =
    useContext(CartContext);
  const TranslationCommon = getLang(langComponent.common);
  const TranslationWorkExchange = getLang(langComponent.workExchange);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    return () => {
      restartForm();
    };
  }, []);

  const handleClose = async () => {
    restartForm();
    onClose();
  };

  const getContentRender = () => {
    if (step === CART_STEP.PAYMENT) {
      return <PaymentForm />;
    }

    return <Items onClose={handleClose} />;
  };

  useEffect(() => {
    if (!charge && !journal) return;

    if (charge?.status === "successful" || journal?.status === 2) {
      // * Remove items
      for (const detail of journal?.details || []) {
        const _item = items.find((i) => i.work === detail.work);

        removeItem(_item._id);
      }

      // TODO: Show success modal
      setIsSuccess(true);
    }
  }, [charge, journal]);

  if (isSuccess) {
    return <PaymentSuccess onClose={handleClose} />;
  }

  return (
    <>
      <Overlay
        onClose={handleClose}
        style={{
          alignItems: "flex-start",
        }}
      >
        <div className="cart">
          <div className="cart-close" onClick={handleClose}>
            <CloseSvg />
            {TranslationCommon("Close")}
          </div>
          <div className="cart-content">
            {getContentRender()}
            <Summary />
          </div>
        </div>
      </Overlay>
    </>
  );
};

Cart.propTypes = {};

export default Cart;
